export default "<p>trainings works!</p>\r\n";